import _RentalCalendarService from "../services/rental-calendar-service";
import { IRentalCalendarService } from "../types/services/rental-calendar-service";

const RentalCalendarService: IRentalCalendarService = new _RentalCalendarService();

export default RentalCalendarService;
